import { ChangeDetectionStrategy, Component, effect, inject, untracked } from '@angular/core';
import { Router } from '@angular/router';
import { PublicRefusalStateComponent } from '../../components/page-states/public-refusal-state.component';
import { MembershipService } from '../../services/membership.service';

/**
 * The refusal face's routed host: the twin of every member-only route renders it for a public-mode caller, at the
 * member path and at any depth below. It owns ONE effect. A route match is evaluated per navigation, never
 * reactively, so a caller matched as public whose public mode then ends (the authentication settled late and they
 * are a member; the brand's switch went off) would sit on the face until they navigated: when public mode turns
 * false while this host is active, it re-runs the router on the current URL in place — the member area matches and
 * the shipped guards answer as on any brand. The other two transitions are the shell's, never this host's: the
 * reverse flip (public mode beginning under a member's page) and public mode ending under a PUBLIC page (the shell
 * re-runs the URL inside the rebuild window so the door's guard runs again).
 */
@Component({
  selector: 'app-public-refusal-route',
  standalone: true,
  imports: [PublicRefusalStateComponent],
  template: '<app-public-refusal-state/>',
  styles: [':host { display: contents; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicRefusalRouteComponent {
  constructor() {
    const router = inject(Router);
    const membership = inject(MembershipService);
    effect(() => {
      if (membership.publicMode()) return;
      // Tracks public mode ALONE: the re-run's own navigation must not re-enter this effect.
      untracked(() => {
        void router.navigateByUrl(router.url, { onSameUrlNavigation: 'reload', replaceUrl: true });
      });
    });
  }
}
